import React, { useEffect } from "react";
import Link from "next/link";
import { useSelector } from "react-redux";
import { parseHtml } from "../../../../utils/common";
import striptags from "striptags";

const FooterMiddle = () => {
  const headerFooterData = useSelector(
    (state) => state.headerFooterData.headerFooterDataList
  );

  const renderNavigationLinks = (title) => {
    const navigationData = headerFooterData?.footer_navigation?.find(
      (nav) => nav?.title === title
    );

    return (
      <div className="footer-col">
        <div className="footer-title">
          <p itemProp="title">{title}</p>
        </div>
        <div className="footer-col-link">
          <ul>
            {navigationData?.footer_pages?.map((page, index) => (
              <li key={index}>
                <Link href={page?.value?.page?.url} itemProp="menu">
                  {parseHtml(striptags(page?.value?.title))}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  useEffect(() => {
    console.clear();
  }, []);
  return (
    <div className="footer-center">
      <div className="row">
        <div className="col-xl-3 col-lg-3 col-md-8 col-sm-8">
          <div className="footer-col">
            <div className="footer-title">
              <p itemProp="title">Our Office</p>
            </div>
            <div className="footer-col-details">
              {headerFooterData?.address?.map((val, index) => {
                return (
                  <div key={index} className="footer-location">
                    <p className="location-name" itemProp="name">
                      {val?.city}
                    </p>
                    <div className="location-details">
                      <address itemProp="address">{val?.address}</address>
                    </div>
                  </div>
                );
              })}

              <div className="footer-contect-details">
                <div className="footer-contect-business">
                  <p>
                    <span>For Business Call: </span>
                   
                      <span
                        style={{
                          fontWeight: "400",
                        }}
                      >
                        {headerFooterData?.site_configuration &&
                          headerFooterData?.site_configuration[0]
                            ?.business_phone_number}
                      </span>
               
                  </p>
                  <p>
                    <span>Email: </span>
                      <span
                        style={{
                          fontWeight: "400",
                        }}
                      >
                        {headerFooterData?.site_configuration &&
                          headerFooterData?.site_configuration[0]
                            ?.business_email}
                      </span>
                  </p>
                </div>
                <div className="footer-contect-careers">
                  <p>
                    <span>For Careers Call: </span>
                      <span
                        className=""
                        style={{
                          fontWeight: "400",
                        }}
                      >
                        {headerFooterData?.site_configuration &&
                          headerFooterData?.site_configuration[0]
                            ?.careers_phone_number}
                      </span>
                  </p>
                  <p>
                    <span>Email: </span>
                   <span
                        style={{
                          fontWeight: "400",
                        }}
                      >
                        {headerFooterData?.site_configuration &&
                          headerFooterData?.site_configuration[0]
                            ?.careers_email}
                      </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4">
          {renderNavigationLinks("Company")}
        </div>
        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4">
          {renderNavigationLinks("Industries")}
        </div>
        <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4">
          {renderNavigationLinks("Services")}
        </div>
        <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4">
          {renderNavigationLinks("Specialties")}
        </div>
      </div>
    </div>
  );
};

export default FooterMiddle;
